/* eslint-disable sort-keys-fix/sort-keys-fix -- CSS-in-JS pseudo-selector keys use semantic ordering */
// MUI v4 Drawer — NS/Tractie component overrides.
// All MUI v4 style classes are declared explicitly (no implicit inheritance on MUI defaults).
// Tractie deviations: paper backgroundColor uses NS nav-bg (sidebar surface), borders use
// NS border-default token instead of MUI palette.divider, no transition.

export const MuiDrawerLightOverrides = {
  root: {},

  docked: {
    flex: '0 0 auto',
  },

  paper: {
    overflowY: 'auto' as const,
    display: 'flex' as const,
    flexDirection: 'column' as const,
    height: '100%',
    flex: '1 0 auto',
    WebkitOverflowScrolling: 'touch',
    position: 'fixed' as const,
    top: 0,
    outline: 0,
    backgroundColor: 'var(--ns-nav-bg)',
    color: 'var(--ns-nav-fg)',
    transition: 'none',
  },

  // Never wider than the viewport, like maxHeight on the top and bottom
  // anchors. Without it a drawer grows with its content, and an autocomplete
  // with long chips pushed its buttons off a narrow screen.
  paperAnchorLeft: {
    left: 0,
    right: 'auto',
    maxWidth: '100%',
  },

  paperAnchorRight: {
    left: 'auto',
    right: 0,
    maxWidth: '100%',
  },

  paperAnchorTop: {
    top: 0,
    left: 0,
    bottom: 'auto',
    right: 0,
    height: 'auto',
    maxHeight: '100%',
  },

  paperAnchorBottom: {
    top: 'auto',
    left: 0,
    bottom: 0,
    right: 0,
    height: 'auto',
    maxHeight: '100%',
  },

  paperAnchorDockedLeft: {
    borderRight: '1px solid var(--ns-color-border-default)',
  },

  paperAnchorDockedTop: {
    borderBottom: '1px solid var(--ns-color-border-default)',
  },

  paperAnchorDockedRight: {
    borderLeft: '1px solid var(--ns-color-border-default)',
  },

  paperAnchorDockedBottom: {
    borderTop: '1px solid var(--ns-color-border-default)',
  },

  modal: {},
} as const;

// Dark palette variant — tokens (--ns-nav-bg, --ns-color-border-default) zijn mode-aware
// via tokens.css. Geen aparte mode-specifieke keys nodig.
export const MuiDrawerDarkOverrides = {
  ...MuiDrawerLightOverrides,
} as const;

// Default props — "geen animatie" (ground-rules.md "Motion and text") geldt ook voor de Slide-wrapper rond
// temporary/persistent variants. `paper.transition: none` raakt alleen het paper-element;
// de slide-in animatie wordt aangestuurd via `transitionDuration` prop. Hier op 0 forceren
// op theme-niveau zodat alle Drawer-variants instant openen/sluiten.
export const MuiDrawerProps = {
  transitionDuration: 0,
} as const;
